import { ReactNode } from 'react';

export const ContactCard = ({ children }: { children: ReactNode }) => <div>{children}</div>;
